// Router basado en hash — deliberadamente el más simple posible: sin
// dependencia externa, sin rutas anidadas ni parámetros dinámicos (ninguna
// vista de esta fase los necesita — Empresas/Usuarios/Dominios/Publicaciones
// son listados de nivel único; el detalle de una empresa, si se necesita a
// futuro, se resuelve dentro de la propia vista con un modal, no con una
// ruta `/empresas/:id`). Hash (`#/ruta`) en vez de History API: estas 3 apps
// se sirven como archivos estáticos (Vite build) sin servidor con rutas de
// fallback a `index.html` garantizado desde el día uno — hash evita 404 en
// refresh sin depender de esa configuración de infraestructura.

/** @type {Map<string, (contenedor: HTMLElement) => void | Promise<void>>} */
const rutas = new Map();

let contenedorRaiz = null;
let rutaNoEncontrada = (contenedor) => {
  contenedor.textContent = 'Página no encontrada.';
};

/**
 * @param {string} ruta ej. '/empresas'
 * @param {(contenedor: HTMLElement) => void | Promise<void>} manejador
 */
export function registrarRuta(ruta, manejador) {
  rutas.set(ruta, manejador);
}

/**
 * @param {(contenedor: HTMLElement) => void} manejador
 */
export function registrarRutaNoEncontrada(manejador) {
  rutaNoEncontrada = manejador;
}

/** @param {string} ruta */
export function navegarA(ruta) {
  window.location.hash = `#${ruta}`;
}

function rutaActual() {
  const hash = window.location.hash.replace(/^#/, '');
  return hash || '/';
}

async function renderizar() {
  if (!contenedorRaiz) return;
  const ruta = rutaActual();
  const manejador = rutas.get(ruta) ?? rutaNoEncontrada;
  contenedorRaiz.innerHTML = '';
  await manejador(contenedorRaiz);
}

/**
 * @param {HTMLElement} contenedor - elemento donde se monta cada vista.
 */
export function iniciarEnrutador(contenedor) {
  contenedorRaiz = contenedor;
  window.addEventListener('hashchange', renderizar);
  renderizar();
}

/**
 * Re-renderiza la ruta actual sin cambiar el hash. Necesario cuando el
 * estado de sesión cambia (login/logout) mientras el usuario sigue en la
 * misma ruta (`/login`, por ejemplo) — `hashchange` no se dispara solo,
 * porque el hash no cambió.
 */
export function refrescarRuta() {
  renderizar();
}
